export default __webpack_public_path__ + "static/media/undraw_operating_system_re_iqsc.445b6256.svg";